module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-7-4dcf2fdbdeea1d0b6467cddff44be320.jpg";